// i150-cart-controls.js
//
// Delegated click/change handlers for the cart drawer (and cart page):
//   1. Per-line subscription selector — "Switch to Autoship & Save" button
//      on one-time lines, frequency dropdown on subscription lines
//      (markup: snippets/i150-subscription-selector.liquid).
//   2. Multi-bottle bundle picker — sets the existing line's quantity to
//      2 / 6 / 12 and the "Switch back to 1 bottle" link
//      (markup: snippets/cart-drawer-bundles.liquid).
//
// WHY DELEGATION:
//   The drawer HTML is replaced wholesale on every cart change (Section
//   Rendering API, quantity stepper, AppStle re-renders). Scripts inside the
//   replaced HTML never run, and per-element listeners are lost. Listening
//   once on `document` means these controls work on every render with no
//   init step and no timing to get wrong.
//
// Loaded once from snippets/cart-drawer.liquid (which the layout renders on
// every page, including /cart).

(function () {
  if (window.__i150CartControlsInstalled) return;
  window.__i150CartControlsInstalled = true;

  function onCartPage() {
    try {
      return !!(window.routes && window.location.pathname === window.routes.cart_url);
    } catch (e) {
      return false;
    }
  }

  // After our own cart write: repaint the drawer (or the cart page).
  // We never intercept other apps' cart writes — see cart-add-refresh.js
  // for why (AppStle refresh loop).
  function afterMutation() {
    if (onCartPage()) {
      try {
        if (typeof publish === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined' &&
            PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'i150-cart-controls' });
          return;
        }
      } catch (e) { /* fall through to reload */ }
      window.location.reload();
      return;
    }

    if (typeof window.i150RefreshCartDrawer === 'function') {
      window.i150RefreshCartDrawer();
    } else {
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
    }
  }

  function changeLine(body) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart change failed: ' + res.status);
      return res.json();
    });
  }

  /* ------------------------------------------------------------
     1. Subscription selector
     ------------------------------------------------------------ */
  function setSelectorBusy(control, on) {
    var wrap = control.closest('.i150-sub-selector') || control;
    wrap.classList.toggle('i150-sub-selector--busy', !!on);
    control.disabled = !!on;
  }

  function switchPlan(control, planId) {
    var lineKey = control.getAttribute('data-line-key');
    var quantity = Number(control.getAttribute('data-quantity')) || 1;
    if (!lineKey) return;

    setSelectorBusy(control, true);

    changeLine({
      id: lineKey,
      quantity: quantity,
      selling_plan: planId ? Number(planId) : ''
    })
      .then(afterMutation)
      .catch(function (err) {
        console.warn('Subscription change failed:', err);
        setSelectorBusy(control, false);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.autoship-line-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    switchPlan(btn, btn.getAttribute('data-plan-id'));
  });

  // Capture phase + stopPropagation: the theme's <cart-items> element
  // listens for any 'change' inside the cart form and treats it as a
  // quantity edit (updateQuantity with an undefined line), which raced our
  // request. Stopping it here keeps that handler from ever seeing the select.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.classList || !sel.classList.contains('i150-sub-select')) return;
    e.stopPropagation();
    if (sel.disabled) return;

    var chosen = sel.value;
    var current = sel.getAttribute('data-current-plan') || '';
    if (String(chosen) === String(current)) return;

    switchPlan(sel, chosen || null);
  }, true);

  /* ------------------------------------------------------------
     2. Multi-bottle bundle picker
     ------------------------------------------------------------ */
  function setBundlesBusy(section, on) {
    if (!section) return;
    section.classList.toggle('is-busy', !!on);
    section.querySelectorAll('button').forEach(function (b) {
      b.disabled = !!on;
    });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.i150-bundle-card, .i150-bundle-reset');
    if (!card) return;
    e.preventDefault();

    var section = card.closest('.i150-bundles');
    if (card.disabled || card.classList.contains('is-selected')) return;
    if (section && section.classList.contains('is-busy')) return;

    var lineKey = card.getAttribute('data-line-key');
    var qty = Number(card.getAttribute('data-qty'));
    if (!lineKey || !qty) return;

    setBundlesBusy(section, true);

    changeLine({ id: lineKey, quantity: qty })
      .then(afterMutation)
      .catch(function (err) {
        console.warn('Bundle change failed:', err);
        setBundlesBusy(section, false);
      });
  });
})();
